import TenantEnum from '../enums/TenantEnum'
import DashMapper from './DashMapper'
import HagertyMapper from './HagertyMapper'
import KeeyPartnersMapper from './KeeyPartnersMapper'
import QuotaxMapper from './QuotaxMapper'
import SwitchMapper from './SwitchMapper'
import TractiveMapper from './TractiveMapper'
import YogaMapper from './Yoga/YogaMapper'
import ZenMapper from './Zen/ZenMapper'
import ZoomcoverMapper from './ZoomcoverMapper'

export default function MapperFactory(tenant: TenantEnum) {
  switch (tenant) {
    case TenantEnum.Dash:
      return new DashMapper()
    case TenantEnum.Hagerty:
      return new HagertyMapper()
    case TenantEnum.Ignite:
      return new YogaMapper() // currently configured like yoga
    case TenantEnum.KeeyPartners:
      return new KeeyPartnersMapper()
    case TenantEnum.Quotax:
      return new QuotaxMapper()
    case TenantEnum.Switch:
      return new SwitchMapper()
    case TenantEnum.Tractive:
      return new TractiveMapper()
    case TenantEnum.Yoga:
      return new YogaMapper()
    case TenantEnum.Zen:
      return new ZenMapper()
    case TenantEnum.Zoomcover:
      return new ZoomcoverMapper()
    case TenantEnum.Demo02:
      return new YogaMapper()
    default:
      throw new Error(`MAPPER: ${tenant} is not a valid tenant.`)
  }
}
